import { camelCase as _camelCase, snakeCase as _snakeCase } from 'lodash-es'

/**
 * Converts all keys in an object to camelCase.
 *
 * @example
 * camelCaseObj({ first_name: 'John', address: { street_name: 'Main St' } })
 *   // returns { firstName:  'John', address: { streetName:  'Main St' } }
 */
export const camelCaseObj = (obj: object): object => {
  if (Array.isArray(obj)) {
    return obj.map(camelCaseObj)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        _camelCase(key),
        camelCaseObj(value),
      ]),
    )
  }
  return obj
}

/**
 * Converts all keys in an object to snake_case.
 *
 * @example
 * snakeCaseObj({ firstName: 'John', address: { streetName: 'Main St' } })
 *   // returns { first_name:  'John', address: { street_name:  'Main St' } }
 */
export const snakeCaseObj = (obj: object): object => {
  if (Array.isArray(obj)) {
    return obj.map(snakeCaseObj)
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        _snakeCase(key),
        snakeCaseObj(value),
      ]),
    )
  }
  return obj
}
